export interface CancelAppointmentOutputDataSuccess {
  type: 'success';
  data: {
    comment?: string;
    notifyClient: boolean;
  };
}

export interface CancelAppointmentOutputDataCancel {
  type: 'cancel';
}

export type CancelAppointmentOutputData =
  | CancelAppointmentOutputDataSuccess
  | CancelAppointmentOutputDataCancel;
